import {fulfilled} from 'lib/promiseMiddlewareHelpers'
import {Map} from 'immutable'
import {deserializeTrip} from 'lib/api/records'
import {apiv3} from 'lib/apiv3'
import {loadAllPages} from 'lib/loadAllPages'

import {LOAD_USER_FAVORITES} from 'lib/api/favorites'

export const LOAD_TRIPS = 'trips/LOAD_TRIPS'

const initialState = Map()

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case fulfilled(LOAD_USER_FAVORITES): {
      const trips = action.payload.extras
        .filter(f => f.type === 'trip')
        .map(f => deserializeTrip(f.trip))

      return state.merge(trips.map(r => [r.id, r]))
    }
    case fulfilled(LOAD_TRIPS): {
      return state.merge(action.payload.results.map(t => [t.id, t]))
    }
    default:
      return state
  }
}

export const loadTrips = (params) => ({
  type: LOAD_TRIPS,
  payload: apiv3.trips.list(params)
})

// provide a callback to store trips in extra-redux places
export const loadAllTrips = (params, callback = null) => (dispatch) => {
  const loadTripsPage = ({pageIndex, perPage}) => (
    dispatch(loadTrips({ page: pageIndex, per_page: perPage, ...params }))
      .then((response) => {
        callback && callback(response)
        return response
      })
  )

  const isLastPage = ({pageIndex, perPage, pageResults}) => (
    (pageIndex + 1) * perPage >= pageResults.value.total_count
  )

  return loadAllPages({
    promiseProducer: loadTripsPage,
    perPage: 200,
    isLastPage: isLastPage
  })
}
